import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SecondaryNavbar from "../HomePage/Navbar/SecondaryNavbar";

import { useLanguage } from "../../context/LanguageContext";

import loginEn from "../../languages/en/login";
import loginTh from "../../languages/th/login";

const LoginPage = () => {
  const { selectedLanguage } = useLanguage(); // Use the context

  const loginData = selectedLanguage === "en" ? loginEn : loginTh;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isEmailValid, setEmailValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(true);

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();

    // Simple email validation
    if (!validateEmail(email)) {
      setEmailValid(false);
      return;
    } else {
      setEmailValid(true);
    }

    // Simple password validation
    const passwordPattern =
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordPattern.test(password)) {
      setPasswordValid(false);
      return;
    } else {
      setPasswordValid(true);
    }

    // Handle form submission
    console.log("Email:", email);
    console.log("Password:", password);

    // Redirect to Email Notification Page
  };

  const validateEmail = (email) => {
    // Simple email validation regex
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  return (
    <div className="relative">
      <SecondaryNavbar />
      <div className="min-h-screen flex items-center justify-center bg-white px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-4">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              {loginData.login}
            </h2>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                {loginData.email}
              </label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                placeholder={loginData.emailPlaceholder}
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`mt-1 block w-full shadow-sm sm:text-sm rounded-lg p-2 pl-6 border 
              ${isEmailValid ? "border-gray-400" : "border-red-500"}`}
              />
              {!isEmailValid && (
                <p className="mt-2 text-sm text-red-500">
                  {loginData.validEmail}
                </p>
              )}
            </div>

            <div>
              <div className="flex items-center justify-between text-sm">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700"
                >
                  {loginData.password}
                </label>
                <a
                  className="font-medium text-gray-400 cursor-pointer hover:text-gray-500"
                  onClick={() => navigate("/forgotPass")}
                >
                  {loginData.forgotPassword}
                </a>
              </div>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                placeholder={loginData.passwordPlaceholder}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`mt-1 block w-full shadow-sm sm:text-sm rounded-lg  p-2 pl-6 border
              ${isPasswordValid ? "border-gray-400" : "border-red-500"}`}
              />
              {!isPasswordValid && (
                <p className="mt-2 text-sm">
                  <span className=" text-red-500 font-semibold">
                    {loginData.validPassword[0]}
                  </span>{" "}
                  <br />
                  {loginData.validPassword[1]} <br />{" "}
                  {loginData.validPassword[2]}{" "}
                  <span className="text-primary-900">
                    {loginData.validPassword[3]}
                  </span>{" "}
                  <br /> {loginData.validPassword[4]} <br />{" "}
                  {loginData.validPassword[5]}
                  <div className="mb-4 mt-1 flex space-x-2">
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                    <div className="w-1/4 h-1 bg-gray-200"></div>
                  </div>
                  <span className=""> {loginData.validPassword[6]} </span>
                </p>
              )}
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  type="checkbox"
                  className="h-4 w-4 text-primary-900 border-gray-300 rounded"
                />
                <label
                  htmlFor="remember-me"
                  className="ml-2 block text-sm text-gray-900"
                >
                  {loginData.rememberMe}
                </label>
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-3xl shadow-sm text-sm font-medium text-white bg-primary-900"
              >
                {loginData.submit}
              </button>
            </div>
          </form>

          <div className=" flex justify-center text-sm mt-0">
            <span className="px-2 font-medium">{loginData.or}</span>
          </div>

          <div>
            <a
              href="#"
              className="font-medium text-black text-sm flex items-center justify-center space-x-2 bg-white p-2 border  rounded-3xl shadow-lg"
            >
              <img
                src={process.env.PUBLIC_URL + "/about us/register/fb.png"}
                width="20"
                height="20"
                className="mr-5"
              />
              Sign up with Facebook
            </a>
          </div>

          <div>
            <p className="text-center text-gray-600 mt-8 text-xs">
              {loginData.policyAndTerms.text}
              <a
                className="font-bold border-b-2 mx-1 cursor-pointer"
                onClick={(e) => {
                  navigate("/termsAndConditions");
                }}
              >
                {loginData.policyAndTerms.terms}
              </a>
              {loginData.policyAndTerms.and}
              <a
                className="font-bold border-b-2 ml-1 cursor-pointer"
                onClick={(e) => {
                  navigate("/policy");
                }}
              >
                {loginData.policyAndTerms.policy}
              </a>
            </p>
          </div>

          <div className="text-sm">
            <p className="mt-8 text-center text-gray-600">
              {loginData.noAccount}{" "}
              <a
                className="font-semibold text-primary-900 cursor-pointer"
                onClick={(e) => {
                  navigate("/register");
                }}
              >
                {loginData.register}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
